import { z } from 'zod';
import '@apexdesigner/schema-tools';
import { belongsTo, hasMany, references } from '@apexdesigner/schema-tools';

export const selectedStudent = z
  .object({
    id: z.number().hidden().describe('Unique identifier'),

    created: z.coerce.date().nullable().optional().hidden().describe('Created'),

    inactive: z
      .boolean()
      .nullable()
      .optional()
      .hidden()
      .describe(
        'Inactive - Retired 4826 checkbox, superseded by inactiveEffectiveDate (opp 3335). Kept in the schema so the startup schema check tolerates databases that still carry the column; no UI or logic reads it',
      ),

    inactiveEffectiveDate: z
      .string()
      .nullable()
      .optional()
      .presentAs('date')
      .describe(
        "Inactive Effective Date - Dropped from this term as of this date, keeping their data and history (opps 4826/3335). Set through the markInactive behavior's confirmation dialog, not edited directly",
      ),

    statusNotes: z
      .string()
      .nullable()
      .optional()
      .presentAs('textarea')
      .describe(
        'Status Notes - Context for status changes (why removed, IEP changes, ...)',
      ),

    termId: z.number().hidden().describe('Foreign key to Term'),

    studentId: z
      .number()
      .presentAs('reference')
      .describe('Foreign key to Student'),

    term: belongsTo('Term'),

    student: references('Student'),

    studentAssignments: hasMany('StudentAssignment'),

    notAvailables: hasMany('NotAvailable'),
  })
  .describe('Joins a student to a term and owns their student assignments.')
  .as('SelectedStudent');

export { selectedStudent as selectedStudentSchema };
